import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectStepSnowSports = (state) => state.get('stepSnowSports');

const makeSelectStepSnowSports = () =>
  createSelector(selectStepSnowSports, (stepSnowSportsState) => ({
    areYouClaimingForSnowSportsOptionalCover: mapWithDefault(
      stepSnowSportsState,
      () =>
        stepSnowSportsState.getIn(['form', 'areYouClaimingForSnowSportsOptionalCover']),
      ''
    ),
    areYouClaimingForSnowSportEquipment: mapWithDefault(
      stepSnowSportsState,
      () => stepSnowSportsState.getIn(['form', 'areYouClaimingForSnowSportEquipment']),
      ''
    ),
    areYouClaimingForSnowEquipmentReplacementHire: mapWithDefault(
      stepSnowSportsState,
      () =>
        stepSnowSportsState.getIn([
          'form',
          'areYouClaimingForSnowEquipmentReplacementHire',
        ]),
      ''
    ),
    areYouClaimingForSnowPrepaidExpenses: mapWithDefault(
      stepSnowSportsState,
      () => stepSnowSportsState.getIn(['form', 'areYouClaimingForSnowPrepaidExpenses']),
      ''
    ),
    areYouClaimingForSnowResortClosure: mapWithDefault(
      stepSnowSportsState,
      () => stepSnowSportsState.getIn(['form', 'areYouClaimingForSnowResortClosure']),
      ''
    ),
    // howItHappened: mapWithDefault(stepSnowSportsState, () => stepSnowSportsState.getIn(['form', 'howItHappened']), ''),
    // whereYouWereInRelationToTheItem: mapWithDefault(stepSnowSportsState, () => stepSnowSportsState.getIn(['form', 'whereYouWereInRelationToTheItem']), ''),
    // additional: mapWithDefault(stepSnowSportsState, () => stepSnowSportsState.getIn(['form', 'additional']), ''),
    // claimingFor: mapWithDefault(stepSnowSportsState, () => stepSnowSportsState.getIn(['form', 'claimingFor']).toJS(), ''),
    // whoDidYouReportThisTo: mapWithDefault(stepSnowSportsState, () => stepSnowSportsState.getIn(['form', 'whoDidYouReportThisTo']), ''),
    // otherDescription: mapWithDefault(stepSnowSportsState, () => stepSnowSportsState.getIn(['form', 'otherDescription']), ''),
    // reportReferenceNumber: mapWithDefault(stepSnowSportsState, () => stepSnowSportsState.getIn(['form', 'reportReferenceNumber']), ''),
    patientName: mapWithDefault(
      stepSnowSportsState,
      () => stepSnowSportsState.getIn(['form', 'patientName']),
      ''
    ),
    relationshipToYou: mapWithDefault(
      stepSnowSportsState,
      () => stepSnowSportsState.getIn(['form', 'relationshipToYou']),
      ''
    ),
    patientDateOfBirth: mapWithDefault(
      stepSnowSportsState,
      () => stepSnowSportsState.getIn(['form', 'patientDateOfBirth']),
      ''
    ),
    medicareNumber: mapWithDefault(
      stepSnowSportsState,
      () => stepSnowSportsState.getIn(['form', 'medicareNumber']),
      ''
    ),
    whatIsYourInjuryOrIllness: mapWithDefault(
      stepSnowSportsState,
      () => stepSnowSportsState.getIn(['form', 'whatIsYourInjuryOrIllness']),
      ''
    ),
    didThisOccurWhilstEngagingInSnowSportActivity: mapWithDefault(
      stepSnowSportsState,
      () =>
        stepSnowSportsState.getIn([
          'form',
          'didThisOccurWhilstEngagingInSnowSportActivity',
        ]),
      ''
    ),
    wasTheInjuredIllTravellerAnInpatient: mapWithDefault(
      stepSnowSportsState,
      () => stepSnowSportsState.getIn(['form', 'wasTheInjuredIllTravellerAnInpatient']),
      ''
    ),
    snowPrepaidCancellationExpenses: mapWithDefault(
      stepSnowSportsState,
      () =>
        stepSnowSportsState.getIn(['form', 'snowPrepaidCancellationExpenses']).toJS(),
      ''
    ),
    snowResortCancellationExpenses: mapWithDefault(
      stepSnowSportsState,
      () =>
        stepSnowSportsState.getIn(['form', 'snowResortCancellationExpenses']).toJS(),
      ''
    ),
    snowPrepaidAdditionalExpenses: mapWithDefault(
      stepSnowSportsState,
      () => stepSnowSportsState.getIn(['form', 'snowPrepaidAdditionalExpenses']).toJS(),
      ''
    ),
    snowResortAdditionalExpenses: mapWithDefault(
      stepSnowSportsState,
      () => stepSnowSportsState.getIn(['form', 'snowResortAdditionalExpenses']).toJS(),
      ''
    ),
    snowSportEquipmentAdditionalItems: mapWithDefault(
      stepSnowSportsState,
      () =>
        stepSnowSportsState.getIn(['form', 'snowSportEquipmentAdditionalItems']).toJS(),
      []
    ),
    snowEquipmentReplacementHireAdditionalItems: mapWithDefault(
      stepSnowSportsState,
      () =>
        stepSnowSportsState
          .getIn(['form', 'snowEquipmentReplacementHireAdditionalItems'])
          .toJS(),
      []
    ),
    snowSportEquipment: mapWithDefault(
      stepSnowSportsState,
      () => stepSnowSportsState.getIn(['form', 'snowSportEquipment']).toJS(),
      ''
    ),
    snowEquipmentReplacementHire: mapWithDefault(
      stepSnowSportsState,
      () => stepSnowSportsState.getIn(['form', 'snowEquipmentReplacementHire']).toJS(),
      ''
    ),
    areThereAnyAdditionalExpensesToBeClaimedSnowPrepaid: mapWithDefault(
      stepSnowSportsState,
      () =>
        stepSnowSportsState.getIn([
          'form',
          'areThereAnyAdditionalExpensesToBeClaimedSnowPrepaid',
        ]),
      ''
    ),
    areThereAnyAdditionalExpensesToBeClaimedSnowResort: mapWithDefault(
      stepSnowSportsState,
      () =>
        stepSnowSportsState.getIn([
          'form',
          'areThereAnyAdditionalExpensesToBeClaimedSnowResort',
        ]),
      ''
    ),
  }));

const makeSelectStepSnowSportsErrors = () =>
  createSelector(selectStepSnowSports, (state) => state.get('errors'));

export { makeSelectStepSnowSports, makeSelectStepSnowSportsErrors };



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepSnowSports/selectors.js